import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";

export const IzostanciDataTable = (props) => {
  const [izostanci, setIzostanci] = useState();
  const [expandedRows, setExpandedRows] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  useEffect(() => {
    setIzostanci(props.data);
  }, [props.data]);

  const headerTemplate = (data) => {
    return (
      <React.Fragment>
        <span>{data.datum}</span>
      </React.Fragment>
    );
  };

  const getOpravdanoText = (rowData) => {
    // console.log(" >>>>>>> rowData: " + rowData.opravdano);
    switch (rowData.opravdano) {
      case true:
        return (
          <span className={"status-opravdano"}>
            Opravdano
          </span>
        );
      case false:
        return (
          <span className={"status-neopravdano"}>
            Neopravdano
          </span>
        );

      default:
        return (
          <span className={"status-cekanje"}>
            Čeka odluku
          </span>
        );
    }
  };

  const onCustomPage = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const paginatorTemplate = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 25, value: 25 },
        { label: 50, value: 50 },
      ];

      return (
        <React.Fragment>
          <span
            className="mx-1"
            style={{ color: "var(--text-color)", userSelect: "none" }}
          >
            Zapisa po stranici:{" "}
          </span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </React.Fragment>
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span
          style={{
            color: "var(--text-color)",
            userSelect: "none",
            width: "120px",
            textAlign: "center",
          }}
        >
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      );
    },
  };

  return (
    <div className="centerText">   
      <DataTable
        value={izostanci}
        rowGroupMode="subheader"
        groupRowsBy="datum"
        responsiveLayout="scroll"
        expandableRowGroups
        stripedRows
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowGroupHeaderTemplate={headerTemplate}
        paginator
        paginatorTemplate={paginatorTemplate}
        first={first}
        rows={rows}
        onPage={onCustomPage}
        paginatorClassName="justify-content-end"
      >
      <Column
        field="datum"
        header="Datum"
        className="table-column-date"
      ></Column>
      <Column 
        field="sat" 
        header="Sat"
      ></Column>
      <Column
        field="naziv_predmeta"
        header="Predmet"
        className="table-column-course"
      ></Column>
      <Column
        field="opravdano"
        header="Opravdano"
        dataType="boolean"
        body={getOpravdanoText}
        className="table-column-course"
      ></Column>
      </DataTable>
    </div>
    
  );
};

export default IzostanciDataTable;
